<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='7' :sm="12")
                el-form-item(label="标题" label-width="65px" )
                    el-input.inputWidth( clearable v-model="dataForm.title" placeholder="按标题搜索")
              el-col(:md='7' :sm="12")
                el-form-item(label="消息类型" )
                    el-select.inputWidth( clearable v-model="dataForm.xType")
                        el-option(label="竞赛" value="1")
                        el-option(label="培训" value="2")
              el-col(:md='7' :sm="12")
                el-form-item(label="发布时间")
                    el-date-picker.inputWidth(  v-model='dataForm.publishTime'  range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addInfo()'  type='primary' v-if="isAuth('pb:msg:add')"  ) 新建消息
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='type',header-align='center',align='center',label='消息类型' width='100')
                template(slot-scope="scope")
                  font() {{{1:'竞赛',2:'培训'}[scope.row.type]}}
            el-table-column(prop='byx1',header-align='center',align='center',label='推送方式' width='150' )
                template(slot-scope="scope")
                  font() {{{'1':'站内消息','2':'手机短信','1,2':'站内消息,手机短信'}[scope.row.byx1]}}
            el-table-column(prop='createTime',header-align='center',align='center',label='发送时间' width='200')
            el-table-column(prop='content',header-align='center',align='center',label='消息内容' :show-overflow-tooltip='true')
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id,scope.row)"   v-if="isAuth('pb:msg:detail')" ) 查看详情
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //新建和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='getDataList')
        //查看
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='getDataList')
</template>

<script>
import AddOrUpdate from './add-or-update'
import QueryView from './query-view'
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: 'ct-competition-clubList',
  data () {
    return {
      isCollapse: true,
      startScoreMin: '',
      StartScoreMax: '',
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      gameInfoVisible: false,
      gamesVisible: false,
      matchId: '',

      pageIndex: 1,
      pageSize: 10,
      tableData: [],
      totalPage: 0,
      dataListLoading: false,
      dataForm: {
        title: '',
        xType: '',
        publishTime: []
      },
      gameForm: {}
    }
  },
  components: {
    AddOrUpdate,
    QueryView

  },
  mounted () {
    this.dataForm.publishTime = get30DaysArray()
    this.getDataList()
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    //新建
    addInfo (id, flagType) {
      this.addOrUpdateVisible = true

      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    //查看
    queryHandle (id, row) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, row)
      })
    },
    sizeChangeHandle (val) {
      this.queryHandle(1, 520)
      this.pageIndex = 1
      this.pageSize = val
      // this.getDataList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    queryList () {
      this.getDataList()
    },
    getDataList () {
      this.dataListLoading = true
      let ctStrTime = null
      let ctEndTime = null
      if (this.dataForm.publishTime !== null) {
        if (this.dataForm.publishTime.length > 0) {
          ctStrTime = this.dataForm.publishTime[0]
          ctEndTime = this.dataForm.publishTime[1]
        }
      }
      this.$http({
        url: this.$http.adornUrl('/pbMessage/list'),
        method: 'post',
        data: {
          page: this.pageIndex,
          limit: this.pageSize,
          strData: ctStrTime,
          endData: ctEndTime,
          title: this.dataForm.title,
          type: this.dataForm.xType
        }
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    }

  }
}
</script>
<style scoped >
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";

.inputWidth {
  width: 210px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

</style>
<style >
.el-input-number--mini .el-input__inner {
    padding-left: 25px;
    padding-right: 25px;
}
.el-input-number--mini .el-input-number__decrease, .el-input-number--mini .el-input-number__increase {
    width: 24px;
    font-size: 12px;
}
.el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 0px;
    vertical-align: top;
}
</style>
